import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import styles from './RangeBox.css';

class RangeBox extends React.Component {
  buttonOptions = [
    { id: 'today', name: 'Today' },
    { id: 'yesterday', name: 'Yesterday' },
    { id: 'this_week', name: 'This Week' },
    { id: 'last_week', name: 'Last Week' },
    { id: 'this_month', name: 'This Month' },
    { id: 'last_month', name: 'Last Month' },
    { id: 'this_year', name: 'This Year' },
    { id: 'last_year', name: 'Last Year' },
  ];

  render() {
    return (
      <div className={styles.wrapper}>
        {this.buttonOptions.map(({ id, name }) => {
          return (
            <div className={`row ${styles.row}`} key={id}>
              <button
                className="btn btn-default btn-block"
                onClick={e => {
                  this._onClickButton(e, id);
                }}
              >
                {name}
              </button>
            </div>
          );
        })}
      </div>
    );
  }

  _onClickButton = (e, id) => {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onChange)
    e.preventDefault();
    e.stopPropagation();

    const startDate = moment();
    let endDate = moment();
    switch (id) {
      case 'today':
        // no op
        break;
      case 'yesterday':
        startDate.startOf('day').add(-1, 'days');
        endDate = moment(startDate).endOf('day');
        break;
      case 'this_week':
        startDate.startOf('week');
        break;
      case 'last_week':
        startDate.startOf('week').add(-1, 'week');
        endDate = moment(startDate).endOf('week');
        break;
      case 'this_month':
        startDate.startOf('month');
        break;
      case 'last_month':
        startDate.startOf('month').add(-1, 'month');
        endDate = moment(startDate).endOf('month');
        break;
      case 'this_year':
        startDate.startOf('year');
        break;
      case 'last_year':
        startDate.startOf('year').add(-1, 'year');
        endDate = moment(startDate).endOf('year');
        break;
    }
    this.props.onChange({ startDate, endDate });
  };
}

RangeBox.propTypes = {
  onChange: PropTypes.func,
};
export default RangeBox;
